import { Setting } from '../../../@paco/entities/Setting/Setting'
import { getSetting } from '../../../@paco/entities/Setting/SettingHelpers'

import { getHours, getUserAge } from '../../../helpers/date'
import UpToAndIncludingDate from '../../../helpers/date/UpToAndIncludingDate'

export const isUserAgeBelow16AndShiftIsAfter19h = (
    settings: Setting[],
    userBirthDay: Date,
    shiftPlanningEnd: UpToAndIncludingDate,
    now: Date,
): boolean => {
    const underAgeSetting = getSetting('ENABLE_CAO_MESSAGE_UNDERAGE_EMPLOYEE', settings)

    if (! underAgeSetting || ! underAgeSetting.isEnabled) {
        return false
    }

    const userAge = getUserAge(now, userBirthDay)
    const hours = getHours(shiftPlanningEnd.date)
    const shiftEndsAfter19 = hours >= 19 || hours <= 3

    return userAge < 16 && shiftEndsAfter19
}
